if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomedImage = null;
      }

      hide() {
        super.hide();
        if (this.zoomedImage) {
          this.zoomedImage.style.transform = '';
          this.zoomedImage.style.cursor = '';
          this.zoomedImage = null;
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const img = activeMedia.querySelector('img');
        if (img) {
          this.enablePinchScrollDoubleTapDragZoom(img);
          this.zoomedImage = img;
        }

        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      enablePinchScrollDoubleTapDragZoom(img) {
        let scale = 1;
        let startDistance = 0;
        let pointers = [];
        let offsetX = 0;
        let offsetY = 0;
        let isDragging = false;
        let startX, startY;

        const applyTransform = () => {
          img.style.transform = `scale(${scale}) translate(${offsetX}px, ${offsetY}px)`;
          img.style.transformOrigin = 'center center';
        };

        const reset = () => {
          startDistance = 0;
          pointers = [];
        };

        // ✅ Pinch Zoom
        img.onpointerdown = (e) => {
          img.setPointerCapture(e.pointerId);
          pointers.push(e);
        };

        img.onpointermove = (e) => {
          pointers = pointers.map((p) => (p.pointerId === e.pointerId ? e : p));

          if (pointers.length === 2) {
            const dx = pointers[1].clientX - pointers[0].clientX;
            const dy = pointers[1].clientY - pointers[0].clientY;
            const newDistance = Math.hypot(dx, dy);

            if (!startDistance) {
              startDistance = newDistance;
              return;
            }

            scale *= newDistance / startDistance;
            scale = Math.max(1, Math.min(scale, 5));
            startDistance = newDistance;

            applyTransform();
          }
        };

        img.onpointerup = reset;
        img.onpointercancel = reset;
        img.onpointerleave = reset;

        // ✅ Scroll Zoom
        img.onwheel = (e) => {
          e.preventDefault();
          scale += e.deltaY < 0 ? 0.1 : -0.1;
          scale = Math.max(1, Math.min(scale, 5));
          applyTransform();
        };

        // ✅ Drag to Move
        img.addEventListener('mousedown', (e) => {
          if (scale <= 1) return;
          e.preventDefault();
          isDragging = true;
          startX = e.clientX - offsetX;
          startY = e.clientY - offsetY;
          img.style.cursor = 'grabbing';
        });

        window.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          offsetX = e.clientX - startX;
          offsetY = e.clientY - startY;
          applyTransform();
        });

        window.addEventListener('mouseup', () => {
          if (isDragging) {
            isDragging = false;
            img.style.cursor = scale > 1 ? 'grab' : '';
          }
        });

        // ✅ Touch Drag
        img.addEventListener('touchstart', (e) => {
          if (scale <= 1 || e.touches.length > 1) return;
          isDragging = true;
          startX = e.touches[0].clientX - offsetX;
          startY = e.touches[0].clientY - offsetY;
        });

        img.addEventListener('touchmove', (e) => {
          if (!isDragging || e.touches.length > 1) return;
          offsetX = e.touches[0].clientX - startX;
          offsetY = e.touches[0].clientY - startY;
          applyTransform();
        });

        img.addEventListener('touchend', () => {
          isDragging = false;
        });

        // ✅ Double Click / Tap Zoom
        let lastTap = 0;
        img.addEventListener('click', (e) => {
          const now = Date.now();
          if (now - lastTap < 300) {
            // double-click or double-tap
            if (scale === 1) {
              scale = 2;
              img.style.cursor = 'grab';
            } else {
              scale = 1;
              offsetX = 0;
              offsetY = 0;
              img.style.cursor = '';
            }
            applyTransform();
          }
          lastTap = now;
        });

        // Optional: cursor change
        img.addEventListener('mouseenter', () => {
          if (scale > 1) img.style.cursor = 'grab';
        });
        img.addEventListener('mouseleave', () => {
          if (!isDragging) img.style.cursor = '';
        });
      }
    }
  );
}
